export type IResetViewDataModal = (modal: IjQueryElmOrHtmlElm) => void;

export function _resetViewDataModal(modal: IjQueryElmOrHtmlElm): void {
  // Modal Elements
  const $modal = $(modal);
  const $modalHeader = $modal.find('.modal-header');
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalLoading = $modal.find('.loading');
  const $dataContainer = $modal.find('.data-container');
  // Empty elements
  $modalHeader.removeClass('hide');
  $modalTitle.html('');
  $modalLoading.removeClass('hide').attr('aria-hidden', 'false');
  $dataContainer.addClass('hide').attr('aria-hidden', 'true').empty();
}
